import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_RuntimeOrganization_ActivationRecords = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Runtime Organization- Activation Records"
    videos={[
      "https://www.youtube.com/embed/Lh00wocupnk",
      "https://www.youtube.com/embed/kZJIeZAT_Xc",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_RuntimeOrganization_ActivationRecords;
